import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Button, Select, message } from "antd";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Formik } from "formik";

import {
  asyncImportRoute,
  asyncSearchAndGetRoute,
} from "../redux/slices/routeSlice";
import "../style/modules/relays.scss";
import ImportModal from "../components/modules/importModal";
import VehicleData from "../components/modules/relay/vehicleData";
import RouteListing from "../components/modules/relay/routeListing";
import ErrorData from "../components/modules/route/errorData";

const { Option } = Select;

const Relays = () => {
  const dispatch = useDispatch();
  const { routeData, importLoading } = useSelector((state) => ({
    routeData: state.route.searchAndGetRoute.data,
    importLoading: state.route.importRoute.loading,
  }));

  const [expandedRowKey, setExpandedRowKey] = useState(null);

  const [messageApi, contextHolder] = message.useMessage();

  const formRef = useRef(null);

  const [file, setFile] = useState(null);
  const [openImportModal, setOpenImportModal] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [openModalError, setOpenModalError] = useState(false);
  const [errorData, setErrorData] = useState([]);
  const [successData, setSuccessData] = useState([]);
  const [formValue, setFormValue] = useState(null);

  const [customers, setCustomers] = useState([]);
  const [periods, setPeriods] = useState([]);
  const [periodYear, setPeriodYear] = useState([]);
  const [routes, setRoutes] = useState([]);

  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedPeriod, setSelectedPeriod] = useState(null);
  const [selectedPeriodYear, setSelectedPeriodYear] = useState(null);
  const [selectedRoute, setSelectedRoute] = useState(null);

  const [isSearchRelayClicked, setIsSearchRelayClicked] = useState(false);

  useEffect(() => {
    setPeriods([...new Set(routeData.map((item) => item.period))]);
    setCustomers([...new Set(routeData.map((item) => item.customer))]);
    setRoutes([...new Set(routeData.map((item) => item.puroute))]);
    setPeriodYear([...new Set(routeData.map((item) => item.periodYear))]);
  }, [routeData]);

  const handleCustomerChange = (value) => {
    setSelectedCustomer(value);
    setSelectedPeriod(null);
    setSelectedRoute(null);
    if (value && value.length > 0) {
      const customerData = routeData.filter((item) =>
        value.includes(item.customer)
      );
      setPeriods([...new Set(customerData.map((item) => item.period))]);
      setRoutes([...new Set(customerData.map((item) => item.puroute))]);
      setPeriodYear([...new Set(customerData.map((item) => item.periodYear))]);
      setSelectedPeriod([...new Set(customerData.map((item) => item.period))]);
      setSelectedRoute([...new Set(customerData.map((item) => item.puroute))]);
      setSelectedPeriodYear([
        ...new Set(customerData.map((item) => item.periodYear)),
      ]);
    } else {
      setPeriods([...new Set(routeData.map((item) => item.period))]);
      setRoutes([...new Set(routeData.map((item) => item.puroute))]);
      setPeriodYear([...new Set(routeData.map((item) => item.periodYear))]);
      setSelectedPeriod(null);
      setSelectedRoute(null);
      setSelectedPeriodYear(null);
    }
  };

  const handlePeriodChange = (value) => {
    setSelectedPeriod(value);

    if (selectedCustomer && selectedCustomer?.length > 0) {
      if (value && value?.length > 0) {
        const matchingData = routeData.filter(
          (item) =>
            selectedCustomer.includes(item.customer) &&
            value.includes(item.period)
        );
        const customerPeriodRoutes = [
          ...new Set(matchingData.map((item) => item.puroute)),
        ];
        const setYear = [
          ...new Set(matchingData.map((item) => item.periodYear)),
        ];
        setPeriodYear(setYear);
        setSelectedPeriodYear(setYear);
        setRoutes(customerPeriodRoutes);
        setSelectedRoute(customerPeriodRoutes);
      } else {
        const customerData = routeData.filter((item) =>
          selectedCustomer.includes(item.customer)
        );
        setPeriodYear([
          ...new Set(customerData.map((item) => item.periodYear)),
        ]);
        setSelectedPeriodYear(null);
        setRoutes([...new Set(customerData.map((item) => item.puroute))]);
        setSelectedRoute(null);
      }
    } else {
      if (value && value.length > 0) {
        const periodRoutes = value.flatMap((period) =>
          routeData
            .filter((item) => item.period === period)
            .map((item) => item.puroute)
        );
        const periodYears = value.flatMap((period) =>
          routeData
            .filter((item) => item.period === period)
            .map((item) => item.periodYear)
        );
        setRoutes([...new Set(periodRoutes)]);
        setSelectedRoute([...new Set(periodRoutes)]);
        setPeriodYear([...new Set(periodYears)]);
        setSelectedPeriodYear([...new Set(periodYears)]);
      } else {
        setRoutes([...new Set(routeData.map((item) => item.puroute))]);
        setSelectedRoute(null);
        setPeriodYear([...new Set(routeData.map((item) => item.periodYear))]);
        setSelectedPeriodYear(null);
      }
    }
  };

  const handlePeriodYearChange = (value) => {
    setSelectedPeriodYear(value);

    if (selectedCustomer && selectedCustomer?.length > 0) {
      if (value && value?.length > 0) {
        const matchingData = routeData.filter(
          (item) =>
            selectedCustomer.includes(item.customer) &&
            value.includes(item.periodYear)
        );
        const customerPeriodYearRoutes = [
          ...new Set(matchingData.map((item) => item.puroute)),
        ];

        setRoutes(customerPeriodYearRoutes);
        setSelectedRoute(customerPeriodYearRoutes);
      } else {
        const customerData = routeData.filter((item) =>
          selectedCustomer.includes(item.customer)
        );

        setRoutes([...new Set(customerData.map((item) => item.puroute))]);
        setSelectedRoute(null);
      }
    } else if (selectedPeriod && selectedPeriod?.length > 0) {
      if (value && value.length > 0) {
        const matchingData = routeData.filter(
          (item) =>
            selectedPeriod.includes(item.period) &&
            value.includes(item.periodYear)
        );
        const customerPeriodYearRoutes = [
          ...new Set(matchingData.map((item) => item.puroute)),
        ];
        setRoutes(customerPeriodYearRoutes);
        setSelectedRoute(customerPeriodYearRoutes);
      } else {
        const periodData = routeData.filter((item) =>
          selectedPeriod.includes(item.period)
        );
        setRoutes([...new Set(periodData.map((item) => item.puroute))]);
        setSelectedRoute(null);
      }
    } else {
      if (value && value.length > 0) {
        const periodYearRoutes = value.flatMap((periodYear) =>
          routeData
            .filter((item) => item.periodYear === periodYear)
            .map((item) => item.puroute)
        );

        setRoutes([...new Set(periodYearRoutes)]);
        setSelectedRoute([...new Set(periodYearRoutes)]);
      } else {
        setRoutes([...new Set(routeData.map((item) => item.puroute))]);
        setSelectedRoute(null);
      }
    }
  };

  const handleSubmit = () => {
    setOpenModalError(false);
    setErrorData([]);
    setSuccessData([]);
    if (file) {
      const formData = new FormData();
      formData.append("upload", file);
      formData.append("isChecked", isChecked || false);

      dispatch(asyncImportRoute(formData)).then((res) => {
        if (res.payload?.status === 200) {
          if (res.payload.data) {
            setErrorData(res.payload.data?.errorData || []);
            setSuccessData(res.payload.data?.newResponse || []);
            setOpenModalError(true);
          }
          setOpenImportModal(false);
          messageApi.open({
            type: "success",
            content: res.payload?.data?.message,
          });
          // dispatch(
          //   asyncGetRoute({
          //     page: 1,
          //     limit: 10,
          //   })
          // );
          dispatch(asyncSearchAndGetRoute());
          setFile(null);
          setIsChecked(false);
        } else {
          setOpenImportModal(false);
          messageApi.open({
            type: "error",
            content: res.payload?.message,
          });
          setFile(null);
          setIsChecked(false);
        }
      });
    } else {
      setOpenImportModal(false);
      messageApi.open({
        type: "error",
        content: "Please select file",
      });
      setIsChecked(false);
    }
  };

  const handleCreateRelay = () => {
    if (selectedRoute === null || selectedRoute?.length === 0) {
      setSelectedData([]);

      messageApi.open({
        type: "error",
        content: "Please select at least one route.",
      });
      return;
    }
    // setExpandedRowKey(null);
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
    const matchingData = routeData?.filter((item) =>
      selectedRoute?.includes(item?.puroute)
    );

    setIsSearchRelayClicked(true);
    setSelectedData(matchingData);
  };

  const initialValue = {
    routeType: "Practical",
    roadNetwork: "State + National Network",
    roads: "Highways & Streets",
    tollRoads: "Discouraged",
    internationalBorders: "Open",
    restrictions: "Use",
    ferries: "Discouraged",
    hubRouting: "Disabled",
    sideOfStreetAdherence: "Off",
    governorSpeedLimit: "Enabled",
    governorSpeedLimitMPH: "55",
    elevation: "Any",
    elevationFT: "7500",
    hazmat: "None",
    siteRouting: "Disabled",
    terminalMaxDistance: "600",
    pilotMaxDistance: "350",
    terminalMaxHours: "11",
    vehicleType: "Truck",
    heightFT: "13",
    heightIN: "6",
    lengthFT: "53",
    lengthIN: "0",
    width: "96",
    weight: "80000",
    axies: "5",
    multipleTrailer: false,
  };

  useLayoutEffect(() => {
    dispatch(asyncSearchAndGetRoute());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      {contextHolder}
      <div className="relay_main_div">
        <div className="relay_left">
          <div className="relay_left_header">
            <div className="table_name">Create Relay </div>
            <div className="relay_header_button">
              <Button
                className="button_margin"
                onClick={() => {
                  setOpenImportModal(true);
                }}
              >
                Import
              </Button>
              {/* <Button
              className="button_margin"
              // onClick={() => {
              //   const filePath = "/sampleSheet/sample_plant.csv";
              //   window.open(filePath, "_blank");
              // }}
            >
              Download Import Template
            </Button> */}
            </div>
          </div>
          <div className="relay_create_select">
            <div>
              <label
                htmlFor="customer1"
                className="form_label_front "
                style={{ paddingRight: "1rem" }}
              >
                Customer
              </label>
            </div>
            <div>
              <Select
                id="customer1"
                placeholder="Select a customer"
                style={{ width: "19rem" }}
                mode="multiple"
                value={selectedCustomer}
                onChange={handleCustomerChange}
                showSearch
                allowClear
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option?.children
                    ?.toLowerCase()
                    ?.indexOf(input?.toLowerCase()) >= 0
                }
              >
                {customers.map((customer, index) => (
                  <Option key={index} value={customer}>
                    {customer}
                  </Option>
                ))}
              </Select>
            </div>
          </div>
          <div className="relay_create_select">
            <div>
              <label
                htmlFor="period1"
                className="form_label_front "
                style={{ paddingRight: "2.5rem" }}
              >
                Period
              </label>
            </div>
            <div>
              <Select
                id="period1"
                placeholder="Select a period"
                style={{ width: "19rem" }}
                mode="multiple"
                value={selectedPeriod}
                onChange={handlePeriodChange}
                showSearch
                allowClear
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option?.children
                    ?.toLowerCase()
                    ?.indexOf(input?.toLowerCase()) >= 0
                }
              >
                {periods.map((period, index) => (
                  <Option key={index} value={period}>
                    {period}
                  </Option>
                ))}
              </Select>
            </div>
          </div>
          <div className="relay_create_select">
            <div>
              <label
                htmlFor="periodYear1"
                className="form_label_front "
                style={{ paddingRight: "0.5rem" }}
              >
                Period Year
              </label>
            </div>
            <div>
              <Select
                id="periodYear1"
                placeholder="Select a period year"
                style={{ width: "19rem" }}
                mode="multiple"
                value={selectedPeriodYear}
                onChange={handlePeriodYearChange}
                showSearch
                allowClear
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option?.children
                    ?.toLowerCase()
                    ?.indexOf(input?.toLowerCase()) >= 0
                }
              >
                {periodYear.map((periodYear, index) => (
                  <Option key={index} value={periodYear}>
                    {periodYear}
                  </Option>
                ))}
              </Select>
            </div>
          </div>
          <div className="relay_create_select">
            <div>
              <label
                htmlFor="puroute1"
                className="form_label_front "
                style={{ paddingRight: "2.8rem" }}
              >
                Route
              </label>
            </div>
            <div>
              <Select
                id="puroute1"
                placeholder="Select a route"
                style={{ width: "19rem" }}
                mode="multiple"
                onChange={(value) => setSelectedRoute(value)}
                value={selectedRoute}
                showSearch
                allowClear
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option?.children
                    ?.toLowerCase()
                    ?.indexOf(input?.toLowerCase()) >= 0
                }
              >
                {routes.map((route, index) => (
                  <Option key={index} value={route}>
                    {route}
                  </Option>
                ))}
              </Select>
            </div>
          </div>

          <div className="relay_create_button">
            <Button htmlType="submit" onClick={() => handleCreateRelay()}>
              Search Relay
            </Button>
          </div>
        </div>
        <Formik
          innerRef={formRef}
          initialValues={initialValue}
          onSubmit={(values) => {
            const newValues = {
              ...values,
              height: `${values.heightFT}'${values.heightIN}''`,
              length: `${values.lengthFT}'${values.lengthIN}''`,
            };
            setFormValue(newValues);
          }}
        >
          {({
            handleChange,
            handleSubmit,
            values,
            setFieldValue,
            errors,
            touched,
          }) => (
            <VehicleData
              handleChange={handleChange}
              handleSubmit={handleSubmit}
              values={values}
              setFieldValue={setFieldValue}
            />
          )}
        </Formik>
      </div>
      <RouteListing
        selectedData={selectedData}
        routes={selectedRoute}
        formValue={formValue}
        expandedRowKey={expandedRowKey}
        setExpandedRowKey={setExpandedRowKey}
        isSearchRelayClicked={isSearchRelayClicked}
        setIsSearchRelayClicked={setIsSearchRelayClicked}
        vehicleFormRef={formRef}
      />
      {openImportModal && (
        <ImportModal
          openModal={openImportModal}
          setOpenModal={setOpenImportModal}
          setFile={setFile}
          handleSubmit={handleSubmit}
          loading={importLoading}
          isChecked={isChecked}
          setIsChecked={setIsChecked}
          isCheckboxShow={true}
        />
      )}
      {openModalError && (
        <ErrorData
          openModal={openModalError}
          setOpenModal={setOpenModalError}
          errorData={errorData}
          successData={successData}
        />
      )}
    </div>
  );
};

export default Relays;
